<template>
  <div
    :class="[
      isTranslation && 'mb-6 relative p-2 border-2 border-green-500',
      isNotTranslation && 'mb-6 relative p-2 border-2 border-red-500',
    ]"
  >
    <!-- show label when language is other than English to represent whether a translation exists or not -->
    <span
      v-if="isTranslation || isNotTranslation"
      class="absolute left-0 inline-block p-1 font-semibold text-white uppercase bottom-100 text-xxs"
      :class="[isTranslation && 'bg-green-500', isNotTranslation && 'bg-red-500']"
    >
      {{ isTranslation ? "It's Translation" : "It's not Translation" }}
    </span>

    <div class="border rounded border-ricoma-gray-300">
      <div class="flex-1 flex-shrink-0 h-48">
        <img
          v-if="video.thumbnail_path"
          :src="video.thumbnail_path"
          alt=""
          class="object-cover object-left-top w-full h-full border-none rounded-t"
        />
      </div>
      <div
        class="flex items-center justify-between h-16 px-2 text-sm font-semibold border-t border-ricoma-gray-300 text-ricoma-gray-500"
      >
        <div class="text-black truncate">{{ video.title }}</div>
        <div class="relative" @click="showOptions = !showOptions" ref="options">
          <VSvgIcon name="dots-vertical" />
          <div
            v-if="showOptions"
            class="absolute top-0 right-0 z-10 w-40 overflow-hidden bg-white rounded shadow-2xl animation-scaling animation-once animation-ease-in-out animation-1/4s"
          >
            <ul>
              <li
                class="flex items-center justify-between px-4 py-3 border-b cursor-pointer border-ricoma-gray-100 hover:bg-ricoma-gray-200"
                @click="$emit('edit', video.id)"
              >
                <span class="mr-12">edit</span>
                <span><VSvgIcon name="pencil" class="w-5" /></span>
              </li>
              <li
                class="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-ricoma-gray-200"
                @click="$emit('delete', video.id)"
              >
                <span>delete</span>
                <span><VSvgIcon name="trash" class="w-5 text-red-500" /></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'VideoCard',
  components: { VSvgIcon },
  data() {
    return {
      showOptions: false,
    };
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  computed: {
    applicable() {
      return Object.prototype.hasOwnProperty.call(this.video, 'is_translation');
    },
    isTranslation() {
      return this.applicable && this.video.is_translation;
    },
    isNotTranslation() {
      return this.applicable && !this.video.is_translation;
    },
  },
  methods: {
    handleClickOutside(e) {
      const element = this.$refs.options;
      if (!(element === e.target || element.contains(e.target))) {
        this.showOptions && (this.showOptions = false);
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscape);
    document.addEventListener('click', this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEscape);
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
